import { Appointment } from 'kb-shared';
import { isToday } from 'kb-shared/utilities/momentHelpers';
import { compareByStartTimeAscending, filterAppointmentsByStartTime } from 'utilities/appointments';

export const filterTodaysAppointmentsByStartTime = (
  appointments: Appointment[] | undefined
): Appointment[] =>
  appointments?.filter((a: Appointment) => {
    return isToday(a.startTime);
  }) || [];

export const getFutureAppointments = (appointments: Appointment[] | undefined): Appointment[] => {
  return filterAppointmentsByStartTime(appointments, false).sort(compareByStartTimeAscending);
};

export const getTodaysAndFutureAppointments = (
  appointments: Appointment[] | undefined
): { todaysAppointments: Appointment[]; futureAppointments: Appointment[] } => {
  const todaysAppointments = filterTodaysAppointmentsByStartTime(appointments).sort(
    compareByStartTimeAscending
  );

  const futureAppointments = getFutureAppointments(
    appointments?.filter(a => !todaysAppointments.includes(a))
  );
  return { todaysAppointments, futureAppointments };
};
